import { css } from 'emotion'

export const ModalButtonStyles = css``
